/// <reference types="@types/googlemaps" />
import { createApp } from 'vue'
import dayjs from 'dayjs'
import ElementPlus from 'element-plus'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import type { ComponentSize } from 'element-plus/lib/utils/types'





dayjs.extend(localizedFormat)

import 'element-plus/theme-chalk/src/index.scss'

import './assets/normalize.css'
import './assets/ev-theme.scss'

import router from './router'
import pinia from './store'

import tokenHandler from './plugins/tokenHandler'

import App from './App.vue'

// 'process.env.BASE_URL', process.env.BASE_URL)

import { useGolfI18nStore } from './store/golf-i18n'

const app = createApp(App)

app.use(pinia)
app.use(router)
app.use(ElementPlus, {
  size: 'medium',
  zIndex: 3000,
})
app.use(tokenHandler)

const golfI18nStore = useGolfI18nStore()
app.config.globalProperties.$t = (
  key: string,
  params?: Record<string, string | number>
) => golfI18nStore.t(key, params)

app.mount('#app')

